import { render, staticRenderFns } from "./LayersTreeItem.vue?vue&type=template&id=05136bc5&scoped=true"
import script from "./LayersTreeItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./LayersTreeItem.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./LayersTreeItem.vue?vue&type=style&index=0&id=05136bc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05136bc5",
  null
  
)

export default component.exports